module.exports = __webpack_public_path__ + "static/media/BenefitTick.dcfa7f83.svg";